<div #widgetContainer class="widget">
  <div
    class="widget__container"
    [style.width]="width + 'px'"
    [style.height]="height + 'px'"
    [style.top]="topOffset + 'px'"
    [style.left]="leftOffset + 'px'"
    [style.transform]="'scale(' + scaleFactor + ')'">
    <iframe
      #widgetFrame
      appEmbedSrc
      allowfullscreen
      id="widget-frame"
      class="widget__frame"
      [model]="model"
      [width]="width"
      [height]="height"
      [style.width]="width + 'px'"
      [style.height]="height + 'px'">
    </iframe>
  </div>
</div>
